import _CastRowQuery from "../__generated__/CastRowQuery.graphql";
import { Suspense } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { CharacterFace, usePhase } from '../avatar/CharacterFace';
import { castFor, speakingIndex } from './cast.ts';
import { QuietBoundary } from './QuietBoundary';
import type { CastRowQuery } from '../__generated__/CastRowQuery.graphql';

// Unauthenticated on the server on purpose (`graphql/query.rs`, `characters`).
const Cast = (_CastRowQuery.hash && _CastRowQuery.hash !== "f6507c57ce314bcf90c28f7761cf0f1b" && console.error("The definition of 'CastRowQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _CastRowQuery);
function Faces() {
  const data = useLazyLoadQuery<CastRowQuery>(Cast, {});
  // One subscription for the row, as `CharacterSelect` has one for its grid.
  const phase = usePhase();
  const cast = castFor(data.characters);
  const speaking = speakingIndex(phase, cast.length);
  return (
    // Hidden from the accessibility tree: the hook line under it says what the
    // row shows, and five unnamed faces would be read out as noise.
    <ul className="flex justify-center gap-2" aria-hidden>
      {cast.map((character, i) => <li key={character.id} className="rise w-14 sm:w-16" style={{
        '--rise-delay': `${i * 40}ms`
      } as React.CSSProperties}>
          <span className="tint block rounded-full p-1" style={{
          '--tutor-accent': character.accentHex
        } as React.CSSProperties}>
            <CharacterFace artKey={character.artKey} accentHex={character.accentHex} intensity={character.intensity} expression={speaking === i ? 'speaking' : 'neutral'} phase={phase} />
          </span>
        </li>)}
    </ul>
  );
}

/** The cast, for a screen before sign-in. Renders nothing until it can, or if it cannot. */
export function CastRow() {
  return <QuietBoundary>
      <Suspense fallback={null}>
        <Faces />
      </Suspense>
    </QuietBoundary>;
}